import React from 'react';
import _ from 'lodash';
import cx from 'classnames';


import { didPropChange } from 'utils/props';
import { KeyCodes } from 'constants/constants';

import Spinner from 'components/Spinner';

// ====================
// PARTIALS
// ====================
export const InputError = ({ ...props }) => (
  <div className="error" {...props} />
)


// ====================
// COMPONENT
// ====================
class Input extends React.Component {
  _inputNode = null
  onInputRef = node => this._inputNode = node
  _getEventValue = e => e.target[this.props.valueKey] |> this.transformOut(#)

  state = {
    focused: false,
  }

  static defaultProps = {
    value: null,
    errors: [],
    placeholder: null,
    valueKey: 'value',
  }

  componentDidMount() {
    this.checkFocus();
  }

  componentDidUpdate(prev, prevState) {
    if(didPropChange(prev, this.props, 'focused'))
      this.checkFocus();
  }

  checkFocus = focused => {
    if(this.props.focused === true || this.props.focused === 'true') {
      setTimeout(() => this.getInput().focus(), 50)
    }
  }

  getInput = () => this._inputNode;
  getValue = value => this.transformOut(value)
  transformIn = value => this.props.transformIn?.(value) ?? value ?? ''
  transformOut = value => this.props.transformOut?.(value) ?? value ?? '';

  onFocus = e => {
    let { name } = e.target;
    let value = this._getEventValue(e);
    this.setState({ focused: true, });
    this.props.onFocus?.(name, value);
  }

  onBlur = e => {
    let { name } = e.target;
    let value = this._getEventValue(e);
    this.setState({ focused: false, });
    this.props.onBlur?.(name, value, e);
  }

  onChange = e => {
    let { name } = e.target;
    let value = this._getEventValue(e);
    this.props.onChange?.(value, name, e);
  }

  onKeyPress = e => {
    if(e.which === KeyCodes.ENTER) {
      this.props.onSubmit?.(this.props.name);
    }
    this.props.onKeyPress?.(e);
  }

  render() {
    let {
      value,
      edited,
      errors,
      transformIn,
      transformOut,
      label,
      labelExtra,
      children,
      helper,
      helperExtra,
      className,
      disabled = false,
      prefix,
      postfix,
      renderInput,
      valueKey,
      focused: propFocused,
      id,
      loading,
      size,
      align = 'left',
      color,
      ...inputProps } = this.props;

    let { focused } = this.state;
    id = id ? `id-${id}` : undefined;
    return (
      <div className={cx('input', className, size, align, color, { focused, disabled, edited, ['with-prefix']: _.isString(prefix), ['with-postfix']: _.isString(postfix) })}>
        {label &&
        <label htmlFor={id}>
          <span className="label-text">{label}</span>
          { labelExtra && 
          <span className="label-extra">{labelExtra}</span>}
        </label>}
        <div className="child-wrap">
          <div className="input-wrap">
            {prefix && <div className="prefix">{prefix}</div>}
            {renderInput?.({
              autoComplete: 'off',
              ...inputProps,
              ref: this.onInputRef,
              value: this.transformIn(value),
              id,
              disabled,
              onChange: this.onChange,
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              onKeyPress: this.onKeyPress,
            })}
            {postfix && <div className="postfix">{postfix}</div>}
          </div>
          {children}
        </div>
        {!_.isEmpty(errors) && <>
          {_.map(errors, (error, idx) => <InputError key={idx}>{error}</InputError>)}
        </>}
        { loading && <Spinner size="s" />}
        {helper &&
          <div className="helper">
            <span>{helper}</span>
            {helperExtra &&
              <span className="helper-extra">{helperExtra}</span>}
          </div>}
      </div>);
  }
}
export default Input;



